export const theme = {
  colors: {
    gradientTop: '#b8c6d0',
    gradientBottom: '#dce4ea',
    primary: '#7499B6',
    primaryLight: '#8fb0c8',
    primaryDark: '#5a7d96',
    textDark: '#1a1a1a',
    textMedium: '#555',
    textLight: '#888',
    textWhite: '#fff',
    surfaceWhite: '#ffffff',
    surfaceCard: 'rgba(255, 255, 255, 0.65)',
    borderLight: '#e0e0e0',
    borderFocus: '#7499B6',
    chipSelected: '#7499B6',
    chipUnselected: 'transparent',
    chipBorder: '#ccc',
    error: '#c33',
    errorBg: '#fee',
    success: '#2e7d32',
    successBg: '#e8f5e9',
    gold: '#ffd700',
  },
  borderRadius: {
    chip: '25px',
    card: '16px',
    button: '50%',
    buttonPill: '25px',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
};
